import * as React from 'react';

const DashboardDefaultPage = React.lazy(() => import('./pages/dashboard/DashboardDefault'));

const ChangePasswordPage = React.lazy(() => import('./pages/auth/ChangePassword'));
const ViewUsersPage = React.lazy(() => import('./pages/auth/ViewUsers'));
const EditUserPage = React.lazy(() => import('./pages/auth/EditUser'))
const RegisterUserPage = React.lazy(() => import('./pages/auth/RegisterUser'));
const AddGroupPage = React.lazy(() => import('./pages/auth/AddGroup'));
const AddServicePage = React.lazy(() => import('./pages/auth/AddService'));

const ShowTasksPage = React.lazy(() => import('./pages/task/ShowTasks'));
const AssignTaskPage = React.lazy(() => import('./pages/task/AssignTask'));
const AddTaskPage = React.lazy(() => import('./pages/task/AddTask'));
const ViewTaskPage = React.lazy(() => import('./pages/task/ViewTask'));

const BrowsePage = React.lazy(() => import('./pages/data/Browse'));

const GstMenuPage = React.lazy(() => import('./pages/gst/GstMenu'));
const GetGstB2bInvoicesPage = React.lazy(() => import('./pages/gst/GstB2BInvoices'));

const ManageWalletPage = React.lazy(() => import('./pages/wallet/ManageWallet'));
const UpdateWalletPage = React.lazy(() => import('./pages/wallet/UpdateBalance'));
const AddFundsPage = React.lazy(() => import('./pages/wallet/AddFunds'));

const ItrPage = React.lazy(() => import('./pages/itr/Itr'));

const routes = [    
    { path: '/dashboard/default', exact: true, name: 'Dashboard', component: DashboardDefaultPage },

    { path: '/app/auth/changepassword', exact: true, name: 'Add Group Page', component: ChangePasswordPage },
    { path: '/app/auth/register', exact: true, name: 'Register User Page', component: RegisterUserPage },
    { path: '/app/auth/viewusers', exact: true, name: 'View Users Page', component: ViewUsersPage },
    { path: '/app/auth/edituser', exact: true, name: 'Edit User Page', component: EditUserPage },
    { path: '/app/manage/addgroup', exact: true, name: 'Add Group Page', component: AddGroupPage },
    { path: '/app/manage/addservice', exact: true, name: 'Add Service Page', component: AddServicePage },

    { path: '/app/task/showtasks', exact: true, name: 'Show Tasks Page', component: ShowTasksPage },
    { path: '/app/task/assigntask', exact: true, name: 'Assign Task Page', component: AssignTaskPage },
    { path: '/app/task/addtask', exact: true, name: 'Add Task Page', component: AddTaskPage },
    { path: '/app/task/viewtask', exact: true, name: 'View Task Page', component: ViewTaskPage },

    { path: '/app/data/browse', exact: true, name: 'Browse Page', component: BrowsePage }, 

    { path: '/app/gst/getgstb2b', exact: true, name: 'GSTR 2A B2B Invoices', component: GetGstB2bInvoicesPage },    
    { path: '/app/gst/getmenu', exact: true, name: 'GSTR Menu', component: GstMenuPage },    

    { path: '/app/manage/wallet', exact: true, name: 'Manage User Wallet', component: ManageWalletPage },    
    { path: '/app/wallet/updatebalance', exact: true, name: 'Update User Wallet', component: UpdateWalletPage },   
    { path: '/app/wallet/addFunds', exact: true, name: 'Add Funds', component: AddFundsPage },

    { path: '/app/itr/home', exact: true, name: 'ITR', component: ItrPage },

];
export default routes;
